import { useSelector } from "react-redux";

import { FBPageWithInsta } from "api/social-account-connect/instagram";
import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";

import { InstagramAccountList } from "../instagram-account-list";
import { InstagramConnectInstructions } from "../instagram-connect-instructions";
import { NeedHelpButton } from "../need-help-button";
import { getAccountsFx, addInstagramAccountFx } from "./model";
import { getConnectButtonStateFactory } from "../connect-button";
import { PlatformTypes } from "features/post";
import { selectSocialConnectInstagramState } from "../../redux-model";

interface InstagramConnectDialogProps {
  show: boolean;
  onHide(): void;
  onBack(): void;
  isAlreadyAdded(acc: FBPageWithInsta): boolean;
}

export function InstagramConnectDialog({
  show,
  onHide,
  onBack,
  isAlreadyAdded,
}: InstagramConnectDialogProps) {
  const { data, gettingData, connectingAccountPageId } = useSelector(
    selectSocialConnectInstagramState
  );

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Connect Instagram Business account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data && data.pages.length > 0 ? (
          <InstagramAccountList
            accounts={data.pages}
            onConnect={(page) => {
              if (data) {
                addInstagramAccountFx({ session: data.session, page });
              }
            }}
            getConnectButtonState={getConnectButtonStateFactory({
              isConnected: isAlreadyAdded,
              isConnecting: (page) => page.page.id === connectingAccountPageId,
              isDisabled: () => Boolean(connectingAccountPageId) || gettingData,
            })}
          />
        ) : (
          <InstagramConnectInstructions
            ButtonProps={{
              disabled: gettingData,
              onClick: getAccountsFx,
            }}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={onBack}>
          Back
        </Button>
        <NeedHelpButton
          platform={PlatformTypes.instagram}
          chatQuery="accounts"
        />
      </Modal.Footer>
    </Modal>
  );
}
